import { Box } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/RicosContext.js";
import { useBiNext } from "./../../_shared/bi-context-provider/bi-context-provider.js";
import { useNodeAttrs } from "./../../_shared/use-node-attrs.js";
import { HTML_BUTTONS } from "./../consts.js";
import {
  Panel,
  PanelHeader,
  SliderWithInput,
  ToggleButton
} from "./../../ui-components/index.js";
import {
  HTML_DIMENSIONS_INPUT,
  HTML_DIMENSIONS_SLIDER,
  HTML_HEIGHT_AUTOHEIGHT_TOGGLE,
  HTML_SLIDER_MODAL
} from "../data-hooks.js";
import { INIT_HEIGHT, INIT_WIDTH } from "../defaults.js";
const SliderModal = ({
  onChange,
  closeModal,
  min,
  max,
  dimension,
  nodeId
}) => {
  const { pmNodeAttrs } = useNodeAttrs(nodeId, "HTML");
  const logBi = useBiNext({ pluginId: "html", modalId: HTML_BUTTONS[dimension], nodeId });
  if (!pmNodeAttrs) {
    return null;
  }
  const value = parseInt(pmNodeAttrs.containerData?.[dimension]?.custom || "") || (dimension === "height" ? INIT_HEIGHT : INIT_WIDTH);
  const naturalIframeHeight = pmNodeAttrs.iframeHeight;
  const autoHeight = pmNodeAttrs.autoHeight ?? true;
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(
    Panel,
    {
      closeButtonProps: { onClick: closeModal },
      height: "fit-content",
      dataHook: HTML_SLIDER_MODAL
    },
    /* @__PURE__ */ React.createElement(
      PanelHeader,
      {
        title: t(
          dimension === "height" ? "HTMLPlugin_SliderModal_Title_Height" : "HTMLPlugin_SliderModal_Title_Width"
        )
      }
    ),
    /* @__PURE__ */ React.createElement(Box, { padding: "18px", direction: "vertical" }, dimension === "height" && pmNodeAttrs.html ? /* @__PURE__ */ React.createElement(
      ToggleButton,
      {
        title: t("HTMLPlugin_SliderModal_Toggle_AutoHeight"),
        dataHook: HTML_HEIGHT_AUTOHEIGHT_TOGGLE,
        size: "medium",
        checked: autoHeight,
        onChange: () => {
          logBi({ dataHook: HTML_HEIGHT_AUTOHEIGHT_TOGGLE, value: !autoHeight });
          onChange({ value, autoHeight: !autoHeight });
        }
      }
    ) : null, /* @__PURE__ */ React.createElement(Box, { paddingTop: "9px" }, /* @__PURE__ */ React.createElement(
      SliderWithInput,
      {
        logBi,
        min,
        max,
        label: null,
        sliderDataHook: HTML_DIMENSIONS_SLIDER,
        inputDataHook: HTML_DIMENSIONS_INPUT,
        onChange: (value2) => {
          onChange({ value: value2, autoHeight });
        },
        value: dimension === "height" && autoHeight && naturalIframeHeight ? naturalIframeHeight : value,
        disabled: dimension === "height" && autoHeight && !!pmNodeAttrs.html,
        normalizeMaxValue: false
      }
    )))
  );
};
export {
  SliderModal
};
//# sourceMappingURL=SliderModal.js.map
